<template>
    <access-denied v-if="accessDenied" title="conta-corrente" />
    <div id="main" v-else>
        <loading :isLoading="isLoading" />
        <div class="page">
            <div class="vertical-flow">
                <div class="registry-wrapper">
                    <div class="columns mt-2">
                        <div class="is-flex is-flex-hbetween is-flex-vtop is-100 mx-3">
                            <div class="is-flex is-flex-column g-2">
                                <p>
                                    <strong>Código: </strong>
                                    {{ contaFlex.idVenFlexErp }}
                                </p>
                                <p>
                                    <strong>Empresa: </strong>
                                    {{ contaFlex.nomeEmpresa }}
                                </p>
                                <p>
                                    <strong>Nome: </strong>
                                    {{ contaFlex.nomeUsuario }}
                                </p>
                            </div>
                            <div class="is-flex is-flex-vbottom g-2">
                                <div class="is-flex is-flex-column g-2">
                                    <label>
                                        {{ $t("ativar-flex") }}
                                    </label>
                                    <b-switch 
                                        v-model="situacaoBool"
                                        size="is-medium"
                                    >
                                    </b-switch>
                                </div>
                                <button
                                    v-if="!integracao && permissao.create"
                                    class="save-btn h-max-content size"
                                    type="button"
                                    tag="button"
                                    @click="promptChangeSituacao"
                                >
                                    {{ $t('salvar') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-half-desktop">
                            <div class="card">
                                <header class="card-header">
                                    <p class="card-header-title">
                                        {{ $t("saldo-disponivel") }}
                                    </p>
                                </header>
                                <div class="card-content">
                                    <div :class="{'content': true, 'green': contaFlex.saldoTotalLiberado > 0, 'red': contaFlex.saldoTotalLiberado < 0 }">
                                        {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(contaFlex.saldoTotalLiberado) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column is-half-desktop">
                            <div class="card">
                                <header class="card-header">
                                    <p class="card-header-title">
                                        {{ $t("saldo-bloqueado") }}
                                    </p>
                                </header>
                                <div class="card-content">
                                    <div class="content orange">
                                        {{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(contaFlex.saldoTotalBloqueado) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="chart-colapse" @click="showChartDebitoCreditoHandle()">
                        Ver grafico dos últimos 6 meses 
                        <b-icon :icon="showChartDebitoCredito ? 'menu-down' : 'menu-right'"></b-icon>
                    </div>
                    <div v-if="showChartDebitoCredito" class="columns">
                        <div class="column" v-if="creditosDebitos.length > 0">
                            <div class="chart-content mt-1">
                                <ChartDebitoCredito :data="creditosDebitos" />
                            </div>
                        </div>
                        <div v-else-if="!isLoading" class="column no-data-info">
                            <p>Nenhum dado a exibir</p>
                        </div>
                    </div>
                    <div v-if="showChartDebitoCredito" class="columns">
                        <div class="column" style="text-align: center;">
                            <button class="save-btn h-max-content size" @click="carregarCreditoEDebitos">Recarregar gráfico</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FlexService from '@/services/vendas/financeiro/FlexService.js';
import ContainerLoader from '@/components/content/loader/ContainerLoader.vue';
import ChartDebitoCredito from '@/components/vendas/financeiro/flex/ChartDebitoCredito.vue'

export default {
    name: 'Geral',

    components: {
        ContainerLoader,
        ChartDebitoCredito
    },

    props: {
        contaFlex: {
            type: Object,
            default: (_) => null,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('VEN_FLEX'),
            service: new FlexService(this.$http, this.$router),
            isLoading: false,
            permissao: {},
            showModal: false,
            accessDenied: false,
            situacaoBool: false,
            creditosDebitos: [],
            showChartDebitoCredito: false
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'financeiro', 'flex');
    },
    watch: {
        contaFlex: {
            handler: function (newValue) {
                this.situacaoBool = Boolean(newValue.situacao)
            },
            deep: true
        } 
    },
    methods: {
        carregarCreditoEDebitos() {
            this.isLoading = true;
            this.$axios
                .get(`/flexChart/grafico-mensal/${this.$route.params.id}.json`)
                .then(this.mapToChart)
                .then((mappedToChart) => {
                    this.creditosDebitos = mappedToChart
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        mapToChart({data}) {
            return data.content.map(chartData => {
                const {
                    valorCredito: totalCredito,
                    valorDebito: totalDebito,
                    data
                } = chartData

                const dataFormatted = new Date(data)
                const monthAndYear = dataFormatted.toLocaleString('pt-BR', { month: 'short', year: 'numeric' });
                const formattedMonthAndYear = monthAndYear.replace(". de ", "/") 
                
                return {
                    totalCredito,
                    totalDebito: Math.abs(totalDebito),
                    nome: formattedMonthAndYear
                }
            })
        },
        promptChangeSituacao() {
            this.isLoading = true;

            const {situacao, ...rest} = this.contaFlex

            const mappedFlexToSend = {
                situacao: Number(this.situacaoBool),
                ...rest
            }
            
            this.service
                .updateSituacao(mappedFlexToSend)
                .then(_ => {
                    const msg = !situacao ? this.$t('flex-ativado-sucesso') : this.$t('flex-inativado-sucesso');

                    this.$root.showMessage('success', msg, true, false);
                })
                .catch(error => {
                    const msg = this.$t('situacao-alterada-erro');

                    this.$root.showMessage('success', msg, true, false);
                })
                .finally(_ => {
                    this.isLoading = false;
                })
        },
        showChartDebitoCreditoHandle() {
            this.showChartDebitoCredito = !this.showChartDebitoCredito;

            if (this.creditosDebitos.length === 0)
                this.carregarCreditoEDebitos();
        }
    },
};
</script>

<style lang="scss" scoped>
.red {
    color: #F44336;
}
.size {
    width: 100px;
}
.h-max-content {
    height: max-content;
}
.g-2 { 
    gap: 8px;
}
.card-content {
    .content {
        font-weight: bold;
        text-align: center;
        font-size: 2.5vw;
    }
}
.green {
    color: #7CB342;
}
.orange {
    color: #FFB300;
}
#main {
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    margin-bottom: 12px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }
    }
}
.no-data-info {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
}
.chart-colapse {
    cursor: pointer; /* Altera o cursor para a mãozinha */
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    background-color: #FFF;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    margin-top: 10px;
    font-weight: 700;
}
</style>
